package org.chiangmeng.qfast.core.data.speech

import kotlinx.browser.window
import org.chiangmeng.qfast.core.domain.ports.TextToSpeechService

class JsTextToSpeechService : TextToSpeechService {
    override fun speak(text: String) {
        try {
            val synth = window.asDynamic().speechSynthesis
            if (synth != null) {
                val utterance = js("new SpeechSynthesisUtterance(text)")
                utterance.lang = "th-TH"
                synth.speak(utterance)
            }
        } catch (_: Throwable) {}
    }
}
